// §J (Addendum June 2026): GBS Gestational Age Window Correction
// Reads GBS thresholds from settings/gbsConfig, falling back to DEFAULT_GBS_CONFIG.
// Any admin update to gbsConfig in Firestore takes effect immediately — no code deploy needed.

import { DEFAULT_GBS_CONFIG, GbsConfig, GBS_CONFIG_DOC, SETTINGS } from '@hb/shared'
import { useMemo } from 'react'
import { useDocument } from '../../../backend/db/hooks'

export const useGbsConfig = (): GbsConfig => {
  const { data } = useDocument<GbsConfig>(SETTINGS, GBS_CONFIG_DOC)

  return useMemo<GbsConfig>(() => ({ ...DEFAULT_GBS_CONFIG, ...data }), [data])
}
